import React from 'react';

export const PrivacyPolicyPage = () => (
    <div className="space-y-6">
        <h2 className="page-title heading-primary-1">Privacy Policy</h2>
        <p className="text-center text-muted">Last updated: April 24, 2026</p>

        <div className="card p-6 rounded-lg shadow-md space-y-4">
            <p className="text-strong">
                Welcome to the Chico Area Dart Association (CADA). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website.
            </p>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">1. Information We Collect</h3>
                <p>We may collect information about you in a variety of ways. The information we may collect on the Site includes:</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-muted">
                    <li>
                        <strong>Personal Data:</strong> Personally identifiable information, such as your name, email address, and telephone number, that you voluntarily give to us when you register for an account.
                    </li>
                    <li>
                        <strong>Profile Data:</strong> Information you choose to provide in your profile, such as a nickname, dart preferences (brand, weight), and home setup details.
                    </li>
                    <li>
                        <strong>League & Match Data:</strong> All data related to your participation in the league, including your team assignments, match schedules, game scores, and individual highlights (e.g., 180s, high outs). This data is linked to your profile.
                    </li>
                    <li>
                        <strong>Derivative Data:</strong> Information our servers automatically collect when you access the Site, such as your IP address, browser type, and the pages you have viewed. We also use local storage to save your site preferences, like your chosen theme.
                    </li>
                </ul>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">2. How We Use Your Information</h3>
                <p>Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-muted">
                    <li>Create and manage your account.</li>
                    <li>Generate league schedules, standings, and player statistics.</li>
                    <li>Display your match history and performance trends on your personal dashboard.</li>
                    <li>Enable member-to-member communications within the secure members' directory.</li>
                    <li>Compile anonymous statistical data for league use.</li>
                    <li>Notify you of updates to the league or your account.</li>
                </ul>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">3. Disclosure of Your Information</h3>
                <p>We do not sell your personal information. We may share information we have collected about you in certain situations:</p>
                <ul className="list-disc list-inside space-y-1 pl-4 text-muted">
                    <li>
                        <strong>Publicly:</strong> League standings, team statistics, and schedules are visible to the public. To protect your privacy, individual player names on public leaderboards may be partially anonymized (e.g., "John D.").
                    </li>
                    <li>
                        <strong>To Other Members:</strong> If you are a registered member, other members may view your profile information, including your name, nickname, and team affiliation. Your phone number is only visible if you explicitly provide it for that purpose.
                    </li>
                    <li>
                        <strong>By Law or to Protect Rights:</strong> If we believe the release of information about you is necessary to respond to legal process or protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law.
                    </li>
                     <li>
                        <strong>Third-Party Service Providers:</strong> We use Firebase (a Google service) for database hosting, authentication, and other backend services. Your data is stored on their secure servers.
                    </li>
                </ul>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">4. Security of Your Information</h3>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">5. Policy for Children</h3>
                <p>
                    We do not knowingly solicit information from or market to children under the age of 13. League participation is restricted to individuals 21 years of age and older.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-xl font-semibold heading-primary-2">6. Contact Us</h3>
                <p>
                    If you have questions or comments about this Privacy Policy, please contact us at: <a href="mailto:chicodarts530@gmail.com" className="text-info font-semibold hover:underline">chicodarts530@gmail.com</a>
                </p>
            </section>
        </div>
    </div>
);